<template>
  <div v-if="isButtonVisible">
    <button
      class="btn btn-hover btn-cart"
      :class="added ? 'btn-primary' : data.class"
      @click.prevent="addToCartWishList"
      :disabled="isDisabled"
    >{{ buttonlabel }}</button>
    <div class="modal-cart" v-show="showModal">
      <div v-if="isDisabled">
        <h4>{{ label_adding_to_cart }}</h4>
      </div>
      <div v-if="!isDisabled">
        <h4>{{ label_added_to_cart }}</h4>

        <a :href="netsuite_url + 'cart'" target="_blank"
           class="btn btn-hover btn-primary btn-cart" @click="showModal = false"
        >{{ label_view_cart }}</a>

        <a class="close btn btn-hover btn-primary btn-wishlist" @click.prevent="showModal = false">{{ label_continue_shopping }}</a>
      </div>
    </div>
    <div class="modal-bg" v-show="showModal"></div>
  </div>
</template>

<script>
export default {
  name: "add-to-cart-child",
  props: {
    data: {},
    netsuite_url: {},
    netsuite_app_url: {},
    label_add_to_cart: {
      type: String,
      default: "Add to Cart"
    },
    label_added_to_cart: {
      type: String,
      default: "Added to Cart"
    },
    label_adding_to_cart: {
      type: String,
      default: "Adding to Cart"
    },
    label_view_cart: {
      type: String,
      default: "View Cart"
    },
    label_continue_shopping: {
      type: String,
      default: "Continue Shopping"
    },
    country: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      cartmode: false,
      isDisabled: false,
      added: false,
      currency: window.currency,
      showModal: false,
      availabilityAU: null,
      locId: 25,
      regionId: 7,
      userType: 'B2C',
    };
  },
  mounted() {
    this.isB2bUser();
    this.setRegionIds();
    },
  methods: {
    setRegionIds(){
      if (window.culture == 'en-nz') {
        this.locId = 16;
        this.regionId = 5;
      }
      if ((window.culture == 'en-us') || (window.culture == 'es-us')) {
        this.locId = 4;
        this.regionId = 4;
      }
    },
    async fetchAvailabilityForAU() {
      let responseAU = await axios.get(this.cartUrlAU, {
        withCredentials: true,
      });
      let availabilityAU = responseAU.data.stockStatus;

      if (this.components && this.components.length > 0) {
        let componentsAvailabilityAU = availabilityAU;
          if (typeof responseAU.data.components === "object") {
            for(const [key, value] of Object.entries(responseAU.data.components)) {
              if (value.stockStatus == "OUT_OF_STOCK") {
                componentsAvailabilityAU = value.stockStatus;
                break;
              } else if ((value.stockStatus == "BACKORDER")) {
                componentsAvailabilityAU = value.stockStatus;
              }
            }
          }
        availabilityAU = componentsAvailabilityAU;
      }
      this.availabilityAU = availabilityAU;

    },
    setCartCount(count) {
      this.$store.commit("wishlist/setCartCount", count);
    },
    addItemTocart(items) {
      if(items && items.length) items.reverse();
      this.isDisabled = true;
      let vm = this;

      var data = [];
      for(var i = 0; i < items.length; i++) {
        if (this.data && this.data.quantity) {
          items[i].qty = items[i].qty * this.data.quantity;
        }
        data.push(
          items[i].isPackage
            ? this.ProductData(
                items[i].netSuiteId,
                items[i].qty,
                "NonInvtPart",
                items[i].hasPackages
              )
            : this.ProductData(items[i].netSuiteId, items[i].qty, "Assembly", items[i].hasPackages)
        );
      }

      jQuery
        .ajax({
          url: this.addToCartUrl,
          method: "POST",
          data: JSON.stringify(
            data
          ),
          xhrFields: {
            withCredentials: true
          }
        })
        .done(function(res) {
          if (res.errorMessage) {
            alert(
              "netSuiteId = " + vm.data.netSuiteId + ">>>" + res.errorMessage
            );
          } else {
            let qtys = res.lines.map(obj => {
              return obj.quantity;
            });

            vm.setCartCount(eval(qtys.join("+")));
          }
          vm.isDisabled = false;
          vm.added = true;
          for(var i = 0; i < items.length; i++) {
              if (items[0].isPackage) vm.$emit("removeFromWishlist", vm.data.stockCode);
          }
        })
        .fail(function(err) {
          alert("An error has occurred adding to cart");
          vm.isDisabled = false;
          console.log(err.responseJSON);
        });
    },
    addToCartWishList() {
      this.showModal = true;
      let vm = this;

      jQuery
        .ajax({
          url: vm.getPackageComponentsUrl,
          method: "GET",
          xhrFields: {
            withCredentials: true
          }
        })
        .done(function(res) {
          if (res.success === true) {
            // console.log("getPackageComponentsUrl", res.data);
            var cartItems = [];
            if (res.data.length) {
              if (!vm.data.netSuiteId) {
                alert("cant add this -> no netSuiteId");
              } else {
                cartItems.push({netSuiteId: vm.data.netSuiteId, qty: 1, isPackage: true, hasPackages: true});
              }

              res.data.forEach(function(PackageComponent) {
                cartItems.push({netSuiteId: PackageComponent.netSuiteId, qty: PackageComponent.qty, isPackage: null, hasPackages: true});
              });
            } else {
              if (!vm.data.netSuiteId) {
                alert("cant add this -> no netSuiteId");
              } else {
                cartItems.push({netSuiteId: vm.data.netSuiteId, qty: 1, isPackage: true, hasPackages: false});
              }
            }

            vm.addItemTocart(cartItems);
          }
        })
        .fail(function(err) {
          alert("An error has occurred adding to cart");
          vm.isDisabled = false;
          console.log(err.responseJSON);
        });
    },
    ProductData(
      netSuiteId = null,
      quantity = 1,
      type = "Assembly",
      hasPackages = null
    ) {
      var product = new Object();
      product["internalid"] = netSuiteId ? netSuiteId : this.data.netSuiteId;
      product["type"] = type;

      var item = new Object();
      item["item"] = product;
      item["quantity"] = quantity;
      if (hasPackages == true)
        item["options"] = [
          {
            cartOptionId: "custcol_rr_pmisca",
            itemOptionId: "",
            label: "PMISCA",
            type: "text",
            value: {
              internalid: '' + this.data.netSuiteParentId+ '',
              label: '"' + this.data.netSuiteParentId + '"'
            }
          }
        ];
      else item["options"] = [];
      item["location"] = "";
      item["fulfillmentChoice"] = "ship";
      item["freeGift"] = false;

      return item;
    },
    isItemNotForSale(item) {
      if (window.culture === 'en-nz') {
        return item.custitemweb_item_not_for_sale_wel === 1;
      } else if (window.culture === 'en-us' || window.culture === 'en-es') {
        return item.custitemweb_item_not_for_sale_den === 1;
      }
      return false;
    },
    isB2bUser() {
      this.userType = this.$store.getters["auth/userType"];
    },
  },
  computed: {
  cartUrlAU() {
      let t = parseInt(Date.now() / 1000);
      return (
        "https://4073460.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=1944&deploy=1&compid=4073460&ns-at=AAEJ7tMQUQJ0VcvlpO7CweYXHyQVBn_B3XmhjJL5r7rXvV8Xp6A" +
        "&itemId=" +
        this.item.internalid +
        "&locId=" +
        this.locId +
        "&state=" +
        this.$store.state.auth.profile.address_state +
        '&t=' + t
      );
    },
    addToCartUrl() {
      return (
        this.netsuite_app_url +
        "services/LiveOrder.Line.Service.ss?c=" + (window.ns_session_var ? window.ns_session_var : "") + "&n=2"
      );
    },
    getPackageComponentsUrl() {
      return (
        (window.culture ? "/" + window.culture : "") +
        "/api/getPackageComponents/" +
        this.data.productId
      );
    },
    buttonlabel() {
      return !this.added
        ? this.label_add_to_cart
        : this.label_added_to_cart;
    },
    item() {
      let item = this.$store.getters["cart/getComponentByStockCode"](this.data.stockCode);
      return item ? item : null;
    },
    isButtonVisible() {
      // if (this.availabilityAU && this.userType ==  'B2B' ) {
      //   if (this.availabilityAU == "IN_STOCK") {
      //     return true;
      //   } else if (
      //     this.availabilityAU == "BACKORDER" && this.userType == 'B2B'
      //   ) {
      //     return true;
      //   } else if (
      //     this.availabilityAU == "CUSTOM_BUILD" ||
      //     this.availabilityAU == "OUT_OF_STOCK"
      //   ) {
      //     return false;
      //   }
      //   return false;
      // }
      let components, netSuiteId, isAlwaysInStock;
      debugger;
      if(this.item) {
          components = [this.item];
          netSuiteId = this.item.netSuiteId;
          isAlwaysInStock = this.item.isAlwaysInStock;

          return this.$store.getters["cart/isAddToCartButtonVisible"](components, netSuiteId, isAlwaysInStock);
      }

      return false;
    },
    cartUrlParams() {
      return this.$store.getters["cart/getCartUrlParams"] ?? '';
    }
  },
    // watch: {
    //   item() {
    //     // if (window.culture == "en-au" || window.culture == "en-nz") {
    //     //   this.fetchAvailabilityForAU();
    //     // }
    // },
  // },
};
</script>

<style>
.modal-cart {
  background: #fff;
  width: 300px;
  height: auto;
  text-align: center;
  position: fixed;
  top: 50%;
  margin-top: -50px;
  left: 50%;
  margin-left: -100px;
  line-height: 25px;
  z-index: 100001;
  padding: 15px;
}
.modal-cart .close,
.modal-cart .close:hover {
  cursor: pointer;
}
.modal-bg {
  background-color: rgba(0, 0, 0, 0.2);
  opacity: 0.2;
  filter: alpha(opacity=20);
  zoom: 1;

  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100000;
}
</style>
